import {
  Button,
  Circle,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';

import { DeleteOutline } from '@r-client/shared/ui/chakra-ui-icons';

export interface IActionModalProps {
  isOpen: boolean;
  icon?: React.ReactNode;
  type?: 'error' | 'success' | 'warning';
  title?: string;
  contentText?: string;
  action?: {
    label: string;
    callback: () => void;
  };
  onClose: () => void;
}

export const ActionModal = ({
  isOpen,
  icon,
  type = 'error',
  title,
  contentText,
  action,
  onClose,
}: IActionModalProps) => (
  <Modal isOpen={isOpen} onClose={onClose} isCentered>
    <ModalOverlay />
    <ModalContent>
      <ModalBody as={VStack} p={12} spacing={6}>
        <Circle size={14} bgColor={`${type}.transparent`}>
          {icon || <DeleteOutline boxSize={5} color={`${type}.default`} />}
        </Circle>
        {(title || contentText) && (
          <VStack spacing={2}>
            {title && <Heading size="admin-h2">{title}</Heading>}
            {contentText && <Text>{contentText}</Text>}
          </VStack>
        )}
        <VStack w="full" spacing={3}>
          {action && (
            <Button
              onClick={action?.callback}
              w="full"
              variant={type === 'success' ? 'primary' : 'destructive'}
            >
              {action?.label}
            </Button>
          )}
          <Button onClick={onClose} w="full" variant="secondary">
            {action ? 'Cancel' : 'Close'}
          </Button>
        </VStack>
      </ModalBody>
    </ModalContent>
  </Modal>
);
